import { render, staticRenderFns } from "./QRDialog.vue?vue&type=template&id=f7c1d97c&scoped=true&"
import script from "./QRDialog.vue?vue&type=script&lang=js&"
export * from "./QRDialog.vue?vue&type=script&lang=js&"
import style0 from "./QRDialog.vue?vue&type=style&index=0&id=f7c1d97c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c1d97c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VDialog})
